import AuthGuard from "./AuthGuard";
import useAuth from "hooks/useAuth";
import React from "react";
import { Navigate } from "react-router-dom";

// For routes that can only be accessed by authenticated regular users
const RegularUserGuard = ({ children }) => {
  const { isSuperuser } = useAuth();

  if (isSuperuser) {
    return <Navigate to="/admin" />;
  }

  return (
    <AuthGuard>
      <React.Fragment>{children}</React.Fragment>
    </AuthGuard>
  );
};

export default RegularUserGuard;
